// extracted by mini-css-extract-plugin
module.exports = {"ModalPaper":"withErrorHandler_ModalPaper__3bIND","ModalStyle":"withErrorHandler_ModalStyle__2SuWU"};